import { t } from 'i18next';
import { InitialPageParam } from 'src/app/helpers/redux.helper';
import { apiSlice } from 'src/app/redux/api/apiSlice';
import { surferApiSlice } from 'src/app/redux/api/surferApiSlice';

import { BlockResultType, NSearchResultType } from 'src/app/services/surfer-service/surfer.service.type';
import { finalUrlsConfig } from 'src/configs/url.config';
import { NSearchRelevantNews, NSearchType } from 'src/types/query.type';

export const nSearchApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    exportNSearchExcell: builder.mutation<ArrayBuffer, { ids?: string[] }>({
      query: (data) => ({
        url: finalUrlsConfig().exports.nsearch,
        method: 'POST',
        body: data,
        responseHandler: async (response: any) => {
          if (!response.ok) {
            const errorResponse = await response.json();
            throw new Error(errorResponse?.message || t('errors.defaultErrorText'));
          }
          return response.blob();
        },
        cache: 'no-cache',
      }),
    }),
  }),
});

export const nSearchSurferApiSlice = surferApiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getNSearch: builder.infiniteQuery<NSearchResultType, NSearchType, InitialPageParam>({
      infiniteQueryOptions: {
        getNextPageParam: <T extends NSearchResultType, K extends InitialPageParam, L extends NSearchType | void>(
          lastPage: T,
          allPages: T[],
          lastPageParam: K,
          allPageParams: K[],
          queryArgs: L,
        ) => {
          const nextOffset = lastPageParam.offset + lastPageParam.limit;
          if (lastPage?.blockDatas?.length < lastPageParam.limit) return undefined;
          return {
            ...lastPageParam,
            offset: nextOffset,
          };
        },
        initialPageParam: { limit: 50, offset: 0 },
      },
      query: ({ pageParam, queryArg }) => {
        return {
          method: 'POST',
          body: queryArg,
          url: finalUrlsConfig().surfer.mediaInsights,
          params: {
            ...pageParam,
          },
        };
      },
      providesTags: [{ type: 'NSearch', id: 'LIST' }],
    }),
    getNSearchRelevantNews: builder.infiniteQuery<BlockResultType[], NSearchRelevantNews, InitialPageParam>({
      infiniteQueryOptions: {
        getNextPageParam: <
          T extends BlockResultType[],
          K extends InitialPageParam,
          L extends NSearchRelevantNews | void,
        >(
          lastPage: T,
          allPages: T[],
          lastPageParam: K,
          allPageParams: K[],
          queryArgs: L,
        ) => {
          const nextOffset = lastPageParam.offset + lastPageParam.limit;
          if (lastPage?.length < lastPageParam.limit) return undefined;
          return {
            ...lastPageParam,
            offset: nextOffset,
          };
        },
        initialPageParam: { limit: 50, offset: 0 },
      },

      query: ({ queryArg, pageParam }) => ({
        method: 'POST',
        body: queryArg,
        url: finalUrlsConfig().surfer.relevantNews,
        params: {
          ...pageParam,
        },
      }),
      providesTags: [{ type: 'NSearch', id: 'LIST' }],
    }),
  }),
});

export const { useExportNSearchExcellMutation } = nSearchApiSlice;
export const { useGetNSearchInfiniteQuery, useGetNSearchRelevantNewsInfiniteQuery } = nSearchSurferApiSlice;
